/**
 * LyteWork Medal Customizer V1.1
 * Bulk medal ordering with clipart/upload, text lines, and ribbon selection
 * Mobile-first, modal-based
 */

(function() {
    'use strict';
    
    console.log('%c[OK] Medal Customizer V1.1 LOADED', 'background: #233354; color: #d6c390; padding: 5px; font-size: 12px;');

    // ========== CLIPART DATA ==========
    const CLIPART = [
        { id: 'baseball', name: 'Baseball', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Base_Ball.png?v=1752809655' },
        { id: 'football', name: 'Football', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/football-ball.png?v=1752940665' },
        { id: 'golf', name: 'Golf Ball', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Golf_Ball.png?v=1752940221' },
        { id: 'pickleball', name: 'Pickleball', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/pickleball_banner.png?v=1752943950' },
        { id: 'soccer', name: 'Soccer Ball', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Soccer_Ball.png?v=1752941289' },
        { id: 'tennis', name: 'Tennis Ball', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Tennis_Ball.png?v=1752942151' }
    ];

    // ========== STATE ==========
    const STORAGE_KEY = 'mc_medal_data_' + window.location.pathname;
    
    const state = {
        medals: [{ line1: '', line2: '', line3: '' }],
        currentPreview: 0,
        imageType: 'none',
        uploadedImage: null,
        uploadedImageName: null,
        selectedClipart: null,
        selectedRibbon: null,
        medalColor: 'gold',
        sportEvent: '',
        variantImage: '',
        productTitle: '',
        variantTitle: '',
        basePrice: 0,
        currentPrice: 0,
        ribbonUpcharge: 0,
        variantId: null,
        sameForAll: false
    };

    let modal = null;
    let scrollY = 0;
    let autosaveTimer = null;

    // ========== AUTOSAVE ==========
    function autosave() {
        clearTimeout(autosaveTimer);
        autosaveTimer = setTimeout(() => {
            const saveData = {
                medals: state.medals,
                imageType: state.imageType,
                selectedClipart: state.selectedClipart,
                selectedRibbon: state.selectedRibbon,
                sameForAll: state.sameForAll
            };
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(saveData));
                console.log('Autosaved medal data');
            } catch (e) { console.log('Autosave failed:', e); }
        }, 500);
    }
    
    function restoreFromAutosave() {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                const data = JSON.parse(saved);
                if (data.medals && data.medals.length > 0) {
                    state.medals = data.medals;
                    state.imageType = data.imageType || 'none';
                    state.selectedClipart = data.selectedClipart || null;
                    state.selectedRibbon = data.selectedRibbon || state.selectedRibbon;
                    state.sameForAll = data.sameForAll || false;
                    console.log('Restored medal data from autosave');
                    return true;
                }
            }
        } catch (e) { console.log('Restore failed:', e); }
        return false;
    }
    
    function clearAutosave() {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }

    // ========== INITIALIZATION ==========
    function init() {
        if (window.MEDAL_RIBBONS) {
            const defaultRibbon = window.getDefaultRibbon();
            if (defaultRibbon) {
                state.selectedRibbon = defaultRibbon.id;
                state.ribbonUpcharge = defaultRibbon.price;
            }
        }
        
        // Restore any saved data
        restoreFromAutosave();
        
        const wrapper = document.querySelector('.mc-trigger-wrapper');
        if (wrapper && !document.getElementById('mc-medals-data')) {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'properties[_medals_data]';
            hidden.id = 'mc-medals-data';
            wrapper.appendChild(hidden);
        }
        
        setupVariantListeners();
    }
    
    function setupVariantListeners() {
        // Ecomify theme uses product-option radio buttons
        document.querySelectorAll('input.product-option[type="radio"], input[name*="option"]').forEach(radio => {
            radio.addEventListener('change', onVariantChange);
        });
        
        // Also watch selects
        document.querySelectorAll('select').forEach(select => {
            select.addEventListener('change', onVariantChange);
        });
        
        // Watch for clicks on color swatch labels
        document.querySelectorAll('.color-swatches label, .product-option-wrapper label').forEach(label => {
            label.addEventListener('click', () => {
                setTimeout(onVariantChange, 150); // Delay for radio to update and image to change
            });
        });
        
        // Watch for splide gallery changes (Ecomify uses splide)
        const splideTrack = document.querySelector('.splide__track');
        if (splideTrack) {
            const observer = new MutationObserver(() => {
                setTimeout(detectVariantImage, 100);
            });
            observer.observe(splideTrack, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] });
            console.log('Splide observer set up');
        }
        
        // Also watch URL changes (variant changes update URL)
        let lastUrl = window.location.href;
        setInterval(() => {
            if (window.location.href !== lastUrl) {
                lastUrl = window.location.href;
                console.log('URL changed, updating variant info');
                onVariantChange();
            }
        }, 500);
        
        console.log('Medal Customizer: Variant listeners set up');
    }
    
    function onVariantChange() {
        detectMedalColor();
        detectSportEvent();
        detectVariantImage();
    }

    // ========== MODAL ==========
    function open() {
        if (modal) {
            syncQuantityFromPage();
            detectMedalColor();
            detectSportEvent();
            detectVariantImage();
            updateHeaderInfo();
            modal.classList.add('active');
            lockBodyScroll();
            updatePrice();
            return;
        }
        
        loadProductData();
        detectMedalColor();
        detectSportEvent();
        detectVariantImage();
        syncQuantityFromPage();
        buildModal();
        lockBodyScroll();
        requestAnimationFrame(() => modal.classList.add('active'));
    }
    
    function syncQuantityFromPage() {
        let targetQty = 1;
        const checkedRadio = document.querySelector('input[name="product-qty-breaks"]:checked');
        if (checkedRadio && checkedRadio.dataset.qty) {
            targetQty = parseInt(checkedRadio.dataset.qty) || 1;
        } else {
            const qtyInput = document.querySelector('input[name="quantity"]');
            if (qtyInput) targetQty = parseInt(qtyInput.value) || 1;
        }
        
        const currentQty = state.medals.length;
        if (targetQty > currentQty) {
            for (let i = currentQty; i < targetQty; i++) {
                state.medals.push({ line1: '', line2: '', line3: '' });
            }
        } else if (targetQty < currentQty) {
            state.medals.splice(targetQty);
        }
        
        if (state.currentPreview >= state.medals.length) state.currentPreview = 0;
        if (modal) { renderMedals(); updateNavButtons(); updatePrice(); }
    }
    
    function detectMedalColor() {
        let colorFound = false;
        let detectedColor = 'gold'; // default
        
        console.log('=== Detecting Medal Color ===');
        
        // Method 1: Ecomify theme - product-option radio buttons (YOUR THEME)
        document.querySelectorAll('input.product-option[type="radio"]:checked, input[name*="option-color"]:checked').forEach(radio => {
            const value = (radio.value || '').toLowerCase();
            console.log('Found Ecomify product-option radio:', radio.value);
            if (value.includes('gold')) { detectedColor = 'gold'; colorFound = true; }
            else if (value.includes('silver')) { detectedColor = 'silver'; colorFound = true; }
            else if (value.includes('bronze')) { detectedColor = 'bronze'; colorFound = true; }
        });
        
        // Method 2: Check labels with aria-label
        if (!colorFound) {
            document.querySelectorAll('label[aria-label]').forEach(label => {
                const input = document.getElementById(label.getAttribute('for'));
                if (input && input.checked) {
                    const ariaLabel = (label.getAttribute('aria-label') || '').toLowerCase();
                    console.log('Found checked label aria-label:', ariaLabel);
                    if (ariaLabel.includes('gold')) { detectedColor = 'gold'; colorFound = true; }
                    else if (ariaLabel.includes('silver')) { detectedColor = 'silver'; colorFound = true; }
                    else if (ariaLabel.includes('bronze')) { detectedColor = 'bronze'; colorFound = true; }
                }
            });
        }
        
        // Method 3: Check ALL select elements
        if (!colorFound) {
            document.querySelectorAll('select').forEach(select => {
                const value = (select.value || '').toLowerCase();
                console.log('Found select:', select.id || select.name, '- Value:', select.value);
                if (value.includes('gold')) { detectedColor = 'gold'; colorFound = true; }
                else if (value.includes('silver')) { detectedColor = 'silver'; colorFound = true; }
                else if (value.includes('bronze')) { detectedColor = 'bronze'; colorFound = true; }
            });
        }
        
        // Method 4: Check the color-swatches-title span for current selection
        if (!colorFound) {
            const colorSpan = document.querySelector('.color-swatches-title .text-muted');
            if (colorSpan) {
                const text = (colorSpan.textContent || '').toLowerCase();
                console.log('Found color-swatches-title span:', text);
                if (text.includes('gold')) { detectedColor = 'gold'; colorFound = true; }
                else if (text.includes('silver')) { detectedColor = 'silver'; colorFound = true; }
                else if (text.includes('bronze')) { detectedColor = 'bronze'; colorFound = true; }
            }
        }
        
        state.medalColor = detectedColor;
        console.log('>>> Final medal color:', state.medalColor);
        
        // Update preview if modal exists
        if (modal) {
            const preview = document.getElementById('mc-medal-preview');
            if (preview) {
                preview.classList.remove('gold', 'silver', 'bronze');
                preview.classList.add(state.medalColor);
            }
        }
    }
    
    function detectSportEvent() {
        state.sportEvent = '';
        
        console.log('=== Detecting Sport/Event ===');
        
        // Method 1: Target the specific Ecomify event-sport select
        const eventSelect = document.querySelector('select[id*="event-sport"], select[id*="option-event"], select.product-option[data-product-handle]');
        if (eventSelect && eventSelect.value) {
            state.sportEvent = eventSelect.value;
            console.log('Found event-sport select:', state.sportEvent);
        }
        
        // Method 2: Check any select that's NOT a color select
        if (!state.sportEvent) {
            document.querySelectorAll('select.product-option, select.form-select').forEach(select => {
                const id = (select.id || '').toLowerCase();
                const value = select.value || '';
                const lower = value.toLowerCase();
                // Skip color-related selects
                if (!id.includes('color') && value.trim() && 
                    !lower.includes('gold') && !lower.includes('silver') && !lower.includes('bronze')) {
                    console.log('Found sport/event from select:', value);
                    state.sportEvent = value;
                }
            });
        }
        
        // Method 3: Check product-option radios that aren't color
        if (!state.sportEvent) {
            document.querySelectorAll('input.product-option[type="radio"]:checked').forEach(radio => {
                const value = radio.value || '';
                const lower = value.toLowerCase();
                if (value.trim() && !lower.includes('gold') && !lower.includes('silver') && !lower.includes('bronze')) {
                    console.log('Found sport/event radio:', value);
                    state.sportEvent = value;
                }
            });
        }
        
        console.log('>>> Final sport/event:', state.sportEvent || '(none found)');
        if (modal) updateHeaderInfo();
    }
    
    function detectVariantImage() {
        console.log('=== Detecting Variant Image ===');
        
        // Reset so we can detect fresh
        state.variantImage = '';
        
        // Method 1: Ecomify theme - get the active splide slide image (the larger d-lg-block one)
        const activeSlideImg = document.querySelector('.splide__slide.is-active .img-fluid.d-lg-block, .splide__slide[aria-hidden="false"] .img-fluid.d-lg-block');
        if (activeSlideImg && activeSlideImg.src && !activeSlideImg.src.includes('data:')) {
            state.variantImage = activeSlideImg.src;
            console.log('Found active splide slide image');
        }
        
        // Method 2: Try the first slide's large image
        if (!state.variantImage) {
            const firstSlideImg = document.querySelector('.splide__slide .img-fluid.d-lg-block');
            if (firstSlideImg && firstSlideImg.src && !firstSlideImg.src.includes('data:')) {
                state.variantImage = firstSlideImg.src;
                console.log('Found first splide slide image');
            }
        }
        
        // Method 3: Any image in product-gallery-wrapper
        if (!state.variantImage) {
            const galleryImg = document.querySelector('.product-gallery-wrapper img.img-fluid[src*="cdn.shopify"]');
            if (galleryImg && galleryImg.src) {
                state.variantImage = galleryImg.src;
                console.log('Found gallery wrapper image');
            }
        }
        
        // Method 4: Try Shopify variant data
        if (!state.variantImage) {
            try {
                const product = window.ShopifyAnalytics?.meta?.product;
                const urlParams = new URLSearchParams(window.location.search);
                let variantId = urlParams.get('variant');
                if (!variantId) {
                    const input = document.querySelector('input[name="id"]');
                    if (input) variantId = input.value;
                }
                if (variantId && product?.variants) {
                    const variant = product.variants.find(v => v.id == variantId);
                    if (variant?.featured_image?.src) {
                        state.variantImage = variant.featured_image.src;
                        console.log('Found image from Shopify variant data');
                    }
                }
            } catch (e) { console.log('Shopify data error:', e); }
        }
        
        console.log('>>> Variant image:', state.variantImage ? 'found' : 'none');
        
        // Update modal if open
        if (modal) {
            const imgEl = document.getElementById('mc-variant-image');
            if (imgEl && state.variantImage) {
                imgEl.src = state.variantImage;
                imgEl.classList.remove('hidden');
            }
        }
    }
    
    function updateHeaderInfo() {
        const subtitleEl = document.getElementById('mc-header-subtitle');
        if (subtitleEl) {
            const text = state.sportEvent || 'Customize Your Medals';
            subtitleEl.textContent = text;
            console.log('Updated header subtitle to:', text);
        }
    }

    function close() {
        if (modal) { modal.classList.remove('active'); unlockBodyScroll(); }
    }

    function lockBodyScroll() {
        scrollY = window.scrollY;
        document.body.classList.add('mc-modal-open');
        document.documentElement.classList.add('mc-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
        document.body.classList.remove('mc-modal-open');
        document.documentElement.classList.remove('mc-modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
    }

    function loadProductData() {
        try {
            const titleEl = document.querySelector('.product__title h1, .product-single__title, h1.product-title');
            if (titleEl) state.productTitle = titleEl.textContent.trim();

            if (window.ShopifyAnalytics?.meta?.product) {
                const product = window.ShopifyAnalytics.meta.product;
                state.productTitle = product.title || state.productTitle;
                
                const variantId = new URLSearchParams(window.location.search).get('variant') ||
                    document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
                
                if (variantId) {
                    const variant = product.variants.find(v => v.id == variantId);
                    if (variant) {
                        state.variantTitle = variant.title !== 'Default Title' ? variant.title : '';
                        state.basePrice = variant.price / 100;
                        state.variantId = variant.id;
                    }
                } else if (product.variants[0]) {
                    state.basePrice = product.variants[0].price / 100;
                }
            }
        } catch (e) { console.warn('Could not load product data:', e); }
    }

    function buildModal() {
        const ribbonsHTML = buildRibbonsHTML();
        const clipartHTML = buildClipartHTML();
        const defaultRibbon = window.getRibbonById ? window.getRibbonById(state.selectedRibbon) : null;
        const ribbonName = defaultRibbon ? defaultRibbon.name : 'Red/White/Blue';
        
        const html = `
            <div id="mc-modal" class="mc-modal">
                <div class="mc-overlay" onclick="window.medalCustomizer.close()"></div>
                <div class="mc-container">
                    <div class="mc-header">
                        <div class="mc-header-left">
                            <img src="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Color_Update_-_2025_-_website.png?v=1764288940" alt="LyteWork" class="mc-logo">
                            <div>
                                <h2>Medal Customizer</h2>
                                <p id="mc-header-subtitle">${state.sportEvent || 'Customize Your Medals'}</p>
                            </div>
                        </div>
                        <button class="mc-close-btn" onclick="window.medalCustomizer.close()">&times;</button>
                    </div>
                    
                    <div class="mc-body">
                        <div class="mc-preview-column">
                            <div class="mc-back-label">BACK OF MEDAL</div>
                            
                            <div class="mc-ribbon-display" id="mc-ribbon-visual">
                                <div class="mc-ribbon-v ${defaultRibbon ? defaultRibbon.type : 'three-color'}" id="mc-ribbon-v" style="${getRibbonStyles(defaultRibbon)}">
                                    <div class="mc-ribbon-v-left"></div>
                                    <div class="mc-ribbon-v-right"></div>
                                    <div class="mc-ribbon-clasp-large"></div>
                                </div>
                            </div>
                            
                            <div class="mc-medal-wrapper">
                                <div class="mc-medal-preview ${state.medalColor}" id="mc-medal-preview">
                                    <img src="" alt="" class="mc-medal-logo empty" id="mc-preview-logo">
                                    <div class="mc-medal-text">
                                        <div class="mc-medal-line empty" id="mc-preview-line1">Line 1</div>
                                        <div class="mc-medal-line empty" id="mc-preview-line2">Line 2</div>
                                        <div class="mc-medal-line empty" id="mc-preview-line3">Line 3</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="mc-preview-nav">
                                <button class="mc-nav-btn" id="mc-prev-btn" onclick="window.medalCustomizer.prevMedal()">&#8249;</button>
                                <div class="mc-preview-indicator">
                                    Medal <input type="number" class="mc-jump-input" id="mc-jump-input" value="1" min="1" onchange="window.medalCustomizer.jumpToMedal(this.value)"> of <span id="mc-total-num">1</span>
                                </div>
                                <button class="mc-nav-btn" id="mc-next-btn" onclick="window.medalCustomizer.nextMedal()">&#8250;</button>
                            </div>
                            
                            <div class="mc-ribbon-indicator">
                                <span class="mc-ribbon-label">Ribbon:</span>
                                <span class="mc-ribbon-selected" id="mc-ribbon-display">${ribbonName}</span>
                            </div>
                            
                            <div class="mc-variant-preview">
                                <div class="mc-front-label">FRONT OF MEDAL</div>
                                <img src="${state.variantImage || ''}" alt="Medal Preview" id="mc-variant-image" class="${state.variantImage ? '' : 'hidden'}">
                            </div>
                        </div>
                        
                        <div class="mc-controls-column">
                            <div class="mc-tabs">
                                <button class="mc-tab active" data-tab="design" onclick="window.medalCustomizer.switchTab('design')">Design</button>
                                <button class="mc-tab" data-tab="ribbon" onclick="window.medalCustomizer.switchTab('ribbon')">Ribbon</button>
                                <button class="mc-tab" data-tab="text" onclick="window.medalCustomizer.switchTab('text')">Text</button>
                            </div>
                            <div class="mc-tab-content-container">
                                <div class="mc-tab-pane active" id="mc-pane-design">
                                    <h3>Logo / Clipart</h3>
                                    <p class="mc-help-text">Add an optional logo or clipart to your medal design.</p>
                                    <div class="mc-image-tabs">
                                        <button class="mc-image-tab ${state.imageType === 'none' ? 'active' : ''}" onclick="window.medalCustomizer.setImageType('none')">None</button>
                                        <button class="mc-image-tab ${state.imageType === 'upload' ? 'active' : ''}" onclick="window.medalCustomizer.setImageType('upload')">Upload</button>
                                        <button class="mc-image-tab ${state.imageType === 'clipart' ? 'active' : ''}" onclick="window.medalCustomizer.setImageType('clipart')">Clipart</button>
                                    </div>
                                    <div class="mc-image-content ${state.imageType === 'upload' ? 'active' : ''}" id="mc-upload-tab">
                                        <div class="mc-upload-area" id="mc-upload-area" onclick="document.getElementById('mc-file-input').click()">
                                            <div class="mc-upload-icon">&#128228;</div>
                                            <div class="mc-upload-text"><strong>Click to upload</strong> your logo<br><small>PNG, JPG, or SVG</small></div>
                                        </div>
                                        <input type="file" id="mc-file-input" accept="image/*" style="display:none" onchange="window.medalCustomizer.handleUpload(this)">
                                        <div class="mc-upload-disclaimer">
                                            <strong>Note:</strong> Your logo will be engraved in the medal's finish color. We may contact you for a higher resolution file if needed.
                                        </div>
                                    </div>
                                    <div class="mc-image-content ${state.imageType === 'clipart' ? 'active' : ''}" id="mc-clipart-tab">
                                        <div class="mc-clipart-grid">${clipartHTML}</div>
                                        <button class="mc-clear-image ${state.selectedClipart ? 'show' : ''}" id="mc-clear-clipart" onclick="window.medalCustomizer.clearClipart()">Clear Selection</button>
                                    </div>
                                </div>
                                
                                <div class="mc-tab-pane" id="mc-pane-ribbon">
                                    <h3>Ribbon Color</h3>
                                    <p class="mc-help-text">Select a ribbon color for your medals.</p>
                                    <div class="mc-ribbon-grid">${ribbonsHTML}</div>
                                </div>
                                
                                <div class="mc-tab-pane" id="mc-pane-text">
                                    <h3>Medal Text</h3>
                                    <p class="mc-help-text">Enter up to 3 lines of text for each medal.</p>
                                    <div class="mc-apply-all-wrapper">
                                        <label class="mc-apply-all-label">
                                            <input type="checkbox" id="mc-same-for-all" onchange="window.medalCustomizer.toggleSameForAll(this.checked)">
                                            <span>Same text for all medals</span>
                                        </label>
                                        <button type="button" class="mc-apply-btn" onclick="window.medalCustomizer.applyToAll()" title="Copy Medal 1 text to all others">Apply to All</button>
                                    </div>
                                    <div class="mc-medals-list" id="mc-medals-list"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="mc-footer">
                        <div class="mc-footer-left">
                            <div class="mc-total-price" id="mc-total-price">$0.00</div>
                            <div class="mc-each-price" id="mc-each-price">$0.00/ea</div>
                        </div>
                        <div class="mc-footer-center">
                            <div class="mc-qty-control">
                                <button type="button" class="mc-qty-btn" onclick="window.medalCustomizer.decreaseQty()">&#8722;</button>
                                <input type="number" class="mc-qty-input" id="mc-qty-input" value="1" min="1" onchange="window.medalCustomizer.setQty(this.value)" onkeyup="window.medalCustomizer.setQty(this.value)">
                                <button type="button" class="mc-qty-btn" onclick="window.medalCustomizer.increaseQty()">+</button>
                            </div>
                        </div>
                        <div class="mc-footer-right">
                            <button class="mc-btn mc-btn-primary" onclick="window.medalCustomizer.addToCart()">Add to Cart</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', html);
        modal = document.getElementById('mc-modal');
        renderMedals();
        updateNavButtons();
        updatePrice();
        updatePreview();
    }
    
    function getRibbonStyles(ribbon) {
        if (!ribbon) return '--ribbon-color-1: #bf0d3e; --ribbon-color-2: #ffffff; --ribbon-color-3: #002868;';
        let styles = `--ribbon-color-1: ${ribbon.colors[0]};`;
        if (ribbon.colors[1]) styles += ` --ribbon-color-2: ${ribbon.colors[1]};`;
        if (ribbon.colors[2]) styles += ` --ribbon-color-3: ${ribbon.colors[2]};`;
        return styles;
    }
    
    function buildRibbonsHTML() {
        if (!window.MEDAL_RIBBONS) return '<p>Ribbons not loaded</p>';
        return window.MEDAL_RIBBONS.map(ribbon => {
            const isSelected = ribbon.id === state.selectedRibbon;
            const swatchClass = ribbon.type;
            let styleVars = `--ribbon-color-1: ${ribbon.colors[0]};`;
            if (ribbon.colors[1]) styleVars += ` --ribbon-color-2: ${ribbon.colors[1]};`;
            if (ribbon.colors[2]) styleVars += ` --ribbon-color-3: ${ribbon.colors[2]};`;
            const priceText = ribbon.price === 0 ? 'Included' : `+$${ribbon.price.toFixed(2)}`;
            const priceClass = ribbon.price > 0 ? 'has-upcharge' : '';
            return `<div class="mc-ribbon-item ${isSelected ? 'selected' : ''}" onclick="window.medalCustomizer.selectRibbon('${ribbon.id}')">
                <div class="mc-ribbon-swatch ${swatchClass}" style="${styleVars}"><div class="mc-ribbon-clasp"></div></div>
                <div class="mc-ribbon-name">${ribbon.name}</div>
                <div class="mc-ribbon-price ${priceClass}">${priceText}</div>
            </div>`;
        }).join('');
    }
    
    function buildClipartHTML() {
        return CLIPART.map(clip => {
            const isSelected = clip.id === state.selectedClipart;
            return `<div class="mc-clipart-item ${isSelected ? 'selected' : ''}" onclick="window.medalCustomizer.selectClipart('${clip.id}')" title="${clip.name}">
                <img src="${clip.url}" alt="${clip.name}">
            </div>`;
        }).join('');
    }

    function setImageType(type) {
        state.imageType = type;
        document.querySelectorAll('.mc-image-tab').forEach(tab => tab.classList.remove('active'));
        document.querySelector(`.mc-image-tab:nth-child(${type === 'none' ? 1 : type === 'upload' ? 2 : 3})`).classList.add('active');
        document.querySelectorAll('.mc-image-content').forEach(c => c.classList.remove('active'));
        if (type === 'upload') document.getElementById('mc-upload-tab').classList.add('active');
        else if (type === 'clipart') document.getElementById('mc-clipart-tab').classList.add('active');
        if (type === 'none') { state.uploadedImage = null; state.selectedClipart = null; }
        updatePreview();
    }
    
    function handleUpload(input) {
        const file = input.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function(e) {
            state.uploadedImage = e.target.result;
            state.uploadedImageName = file.name;
            state.imageType = 'upload';
            state.selectedClipart = null;
            const area = document.getElementById('mc-upload-area');
            area.classList.add('has-file');
            area.innerHTML = `<img src="${state.uploadedImage}" alt="Uploaded" class="mc-upload-preview"><div class="mc-upload-filename">${file.name}</div><button class="mc-upload-remove" onclick="event.stopPropagation(); window.medalCustomizer.removeUpload()">Remove</button>`;
            updatePreview();
            autosave();
        };
        reader.readAsDataURL(file);
    }
    
    function removeUpload() {
        state.uploadedImage = null;
        state.uploadedImageName = null;
        const area = document.getElementById('mc-upload-area');
        area.classList.remove('has-file');
        area.innerHTML = `<div class="mc-upload-icon">&#128228;</div><div class="mc-upload-text"><strong>Click to upload</strong> your logo<br><small>PNG, JPG, or SVG</small></div>`;
        document.getElementById('mc-file-input').value = '';
        updatePreview();
        autosave();
    }
    
    function selectClipart(clipId) {
        state.selectedClipart = clipId;
        state.imageType = 'clipart';
        state.uploadedImage = null;
        document.querySelectorAll('.mc-clipart-item').forEach(item => item.classList.remove('selected'));
        event.currentTarget.classList.add('selected');
        document.getElementById('mc-clear-clipart').classList.add('show');
        updatePreview();
    }
    
    function clearClipart() {
        state.selectedClipart = null;
        document.querySelectorAll('.mc-clipart-item').forEach(item => item.classList.remove('selected'));
        document.getElementById('mc-clear-clipart').classList.remove('show');
        updatePreview();
    }

    function selectRibbon(ribbonId) {
        const ribbon = window.getRibbonById(ribbonId);
        if (!ribbon) return;
        state.selectedRibbon = ribbonId;
        state.ribbonUpcharge = ribbon.price;
        document.querySelectorAll('.mc-ribbon-item').forEach(item => item.classList.remove('selected'));
        event.currentTarget.classList.add('selected');
        document.getElementById('mc-ribbon-display').textContent = ribbon.name;
        
        const ribbonV = document.getElementById('mc-ribbon-v');
        if (ribbonV) {
            ribbonV.className = 'mc-ribbon-v ' + ribbon.type;
            ribbonV.style.cssText = getRibbonStyles(ribbon);
        }
        updatePrice();
    }

    function renderMedals() {
        const container = document.getElementById('mc-medals-list');
        if (!container) return;
        container.innerHTML = state.medals.map((medal, index) => `
            <div class="mc-medal-card ${index === state.currentPreview ? 'active' : ''}" data-index="${index}">
                <div class="mc-card-header">
                    <span class="mc-medal-number">Medal ${index + 1}</span>
                    ${state.medals.length > 1 ? `<button class="mc-remove-btn" onclick="window.medalCustomizer.removeMedal(${index})" title="Remove medal">&#215;</button>` : ''}
                </div>
                <div class="mc-card-inputs">
                    <input type="text" class="mc-input" placeholder="Line 1 (e.g., Event Name)" value="${escapeHtml(medal.line1)}" onfocus="window.medalCustomizer.setPreview(${index})" oninput="window.medalCustomizer.updateMedal(${index}, 1, this.value)">
                    <input type="text" class="mc-input" placeholder="Line 2 (e.g., Award/Place)" value="${escapeHtml(medal.line2)}" onfocus="window.medalCustomizer.setPreview(${index})" oninput="window.medalCustomizer.updateMedal(${index}, 2, this.value)">
                    <input type="text" class="mc-input" placeholder="Line 3 (e.g., Date/Year)" value="${escapeHtml(medal.line3)}" onfocus="window.medalCustomizer.setPreview(${index})" oninput="window.medalCustomizer.updateMedal(${index}, 3, this.value)">
                </div>
            </div>
        `).join('');
        updateQuantityDisplay();
        updatePreview();
    }

    function addMedal() {
        state.medals.push({ line1: '', line2: '', line3: '' });
        state.currentPreview = state.medals.length - 1;
        renderMedals();
        updateNavButtons();
        updatePrice();
        setTimeout(() => {
            const cards = document.querySelectorAll('.mc-medal-card');
            const lastCard = cards[cards.length - 1];
            if (lastCard) {
                lastCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                lastCard.querySelector('.mc-input')?.focus();
            }
        }, 100);
    }

    function removeMedal(index) {
        if (state.medals.length <= 1) return;
        state.medals.splice(index, 1);
        if (state.currentPreview >= state.medals.length) state.currentPreview = state.medals.length - 1;
        else if (state.currentPreview > index) state.currentPreview--;
        renderMedals();
        updateNavButtons();
        updatePrice();
    }

    function updateMedal(medalIndex, lineNum, value) {
        state.medals[medalIndex][`line${lineNum}`] = value;
        if (medalIndex === state.currentPreview) updatePreview();
        saveToHiddenField();
        autosave();
    }

    function setPreview(index) {
        if (index < 0 || index >= state.medals.length) return;
        state.currentPreview = index;
        document.querySelectorAll('.mc-medal-card').forEach((card, i) => card.classList.toggle('active', i === index));
        updatePreview();
        updateNavButtons();
    }

    function updatePreview() {
        const medal = state.medals[state.currentPreview];
        if (!medal) return;
        
        const line1El = document.getElementById('mc-preview-line1');
        const line2El = document.getElementById('mc-preview-line2');
        const line3El = document.getElementById('mc-preview-line3');
        const logoEl = document.getElementById('mc-preview-logo');
        
        if (line1El) { line1El.textContent = medal.line1 || 'Line 1'; line1El.classList.toggle('empty', !medal.line1); }
        if (line2El) { line2El.textContent = medal.line2 || 'Line 2'; line2El.classList.toggle('empty', !medal.line2); }
        if (line3El) { line3El.textContent = medal.line3 || 'Line 3'; line3El.classList.toggle('empty', !medal.line3); }
        
        if (logoEl) {
            if (state.imageType === 'upload' && state.uploadedImage) {
                logoEl.src = state.uploadedImage;
                logoEl.classList.remove('empty');
            } else if (state.imageType === 'clipart' && state.selectedClipart) {
                const clip = CLIPART.find(c => c.id === state.selectedClipart);
                if (clip) { logoEl.src = clip.url; logoEl.classList.remove('empty'); }
            } else {
                logoEl.src = '';
                logoEl.classList.add('empty');
            }
        }
        
        const jumpInput = document.getElementById('mc-jump-input');
        if (jumpInput) {
            jumpInput.value = state.currentPreview + 1;
            jumpInput.max = state.medals.length;
        }
        document.getElementById('mc-total-num').textContent = state.medals.length;
    }
    
    function jumpToMedal(num) {
        const index = parseInt(num) - 1;
        if (index >= 0 && index < state.medals.length) {
            setPreview(index);
            scrollToMedal(index);
        } else {
            // Reset to valid value
            const jumpInput = document.getElementById('mc-jump-input');
            if (jumpInput) jumpInput.value = state.currentPreview + 1;
        }
    }

    function prevMedal() { if (state.currentPreview > 0) { setPreview(state.currentPreview - 1); scrollToMedal(state.currentPreview); } }
    function nextMedal() { if (state.currentPreview < state.medals.length - 1) { setPreview(state.currentPreview + 1); scrollToMedal(state.currentPreview); } }
    function scrollToMedal(index) { const cards = document.querySelectorAll('.mc-medal-card'); if (cards[index]) cards[index].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    function updateNavButtons() {
        const prevBtn = document.getElementById('mc-prev-btn');
        const nextBtn = document.getElementById('mc-next-btn');
        if (prevBtn) prevBtn.disabled = state.currentPreview === 0;
        if (nextBtn) nextBtn.disabled = state.currentPreview >= state.medals.length - 1;
    }

    function updateQuantityDisplay() {
        const count = state.medals.length;
        const qtyEl = document.getElementById('mc-quantity');
        if (qtyEl) qtyEl.textContent = count;
        updateShopifyQuantity(count);
        updatePrice();
    }

    function updateShopifyQuantity(qty) {
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) { qtyInput.value = qty; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    function updatePrice() {
        const quantity = state.medals.length;
        let unitPrice = state.basePrice;
        
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        let bestTier = null;
        radios.forEach(r => {
            const tierQty = parseInt(r.dataset.qty);
            if (tierQty <= quantity && (!bestTier || tierQty > bestTier.qty)) bestTier = { qty: tierQty, el: r };
        });
        
        if (bestTier) {
            if (!bestTier.el.checked) bestTier.el.checked = true;
            const rawPrice = bestTier.el.dataset.totalPrice;
            if (rawPrice) unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) / bestTier.qty;
        } else { radios.forEach(r => r.checked = false); }
        
        state.currentPrice = unitPrice;
        const ribbonTotal = state.ribbonUpcharge * quantity;
        const total = (unitPrice * quantity) + ribbonTotal;
        const perUnit = unitPrice + state.ribbonUpcharge;
        
        const totalEl = document.getElementById('mc-total-price');
        const eachEl = document.getElementById('mc-each-price');
        const qtyInput = document.getElementById('mc-qty-input');
        
        if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
        if (eachEl) eachEl.textContent = '$' + perUnit.toFixed(2) + '/ea';
        if (qtyInput) qtyInput.value = quantity;
    }

    function addToCart() {
        // Validation - require at least line 1 on first medal
        if (!state.medals[0].line1.trim()) {
            showNotification('Please enter at least Line 1 for Medal 1', 'error');
            setPreview(0);
            const firstInput = document.querySelector('.mc-medal-card input');
            if (firstInput) firstInput.focus();
            return;
        }
        
        saveToHiddenField();
        
        // Get the correct variant ID - try multiple methods
        let variantId = 
            // Method 1: URL parameter
            new URLSearchParams(window.location.search).get('variant') ||
            // Method 2: Shopify analytics (most reliable)
            window.ShopifyAnalytics?.meta?.selectedVariantId ||
            // Method 3: Hidden input in any form
            document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
            // Method 4: Select dropdown
            document.querySelector('form[action*="/cart/add"] select[name="id"]')?.value ||
            // Method 5: Checked radio
            document.querySelector('input[name="id"]:checked')?.value;
        
        console.log('Medal Customizer - Variant ID:', variantId);
        
        if (!variantId) {
            showNotification('Could not find product variant. Please refresh and try again.', 'error');
            return;
        }
        
        // Build properties object
        const properties = {};
        
        const ribbon = window.getRibbonById(state.selectedRibbon);
        const ribbonName = ribbon ? ribbon.name : 'None';
        const ribbonPrice = ribbon && ribbon.price > 0 ? ` (+$${ribbon.price.toFixed(2)}/ea)` : '';
        
        if (state.sportEvent) properties['Sport/Event'] = state.sportEvent;
        properties['Ribbon'] = ribbonName + ribbonPrice;
        
        if (state.imageType === 'upload' && state.uploadedImage) {
            properties['Logo/Clipart'] = 'Customer Upload: ' + (state.uploadedImageName || 'logo');
        } else if (state.imageType === 'clipart' && state.selectedClipart) {
            const clip = CLIPART.find(c => c.id === state.selectedClipart);
            properties['Logo/Clipart'] = clip ? clip.name : state.selectedClipart;
        } else {
            properties['Logo/Clipart'] = 'None';
        }
        
        // Check if all medals are the same
        const firstMedal = state.medals[0];
        const allSame = state.medals.every(m => 
            m.line1 === firstMedal.line1 && 
            m.line2 === firstMedal.line2 && 
            m.line3 === firstMedal.line3
        );
        
        if (allSame && state.medals.length > 1) {
            // All medals identical - just show one entry
            properties['Medal Text (All Same)'] = `${firstMedal.line1 || '-'} | ${firstMedal.line2 || '-'} | ${firstMedal.line3 || '-'}`;
        } else {
            // Different medals - list each one
            state.medals.forEach((medal, i) => {
                properties[`Medal ${i + 1}`] = `${medal.line1 || '-'} | ${medal.line2 || '-'} | ${medal.line3 || '-'}`;
            });
        }
        
        properties['Total Medals'] = state.medals.length.toString();
        
        const csvLines = ['Line 1,Line 2,Line 3'];
        state.medals.forEach(m => csvLines.push(`${escapeCSV(m.line1)},${escapeCSV(m.line2)},${escapeCSV(m.line3)}`));
        properties['_Medals CSV'] = csvLines.join('\n');
        
        const medalCount = state.medals.length;
        
        // Use AJAX to add to cart
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: medalCount,
                properties: properties
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add to cart');
            }
            return response.json();
        })
        .then(data => {
            console.log('Added to cart:', data);
            clearAutosave();
            close();
            showNotification('Added to cart!', 'success');
            // Redirect to cart after short delay
            setTimeout(() => {
                window.location.href = '/cart';
            }, 500);
        })
        .catch(error => {
            console.error('Cart error:', error);
            showNotification('Failed to add to cart. Please try again.', 'error');
        });
    }
    
    function escapeCSV(str) { if (!str) return ''; return str.includes(',') || str.includes('"') || str.includes('\n') ? '"' + str.replace(/"/g, '""') + '"' : str; }
    function addHiddenInput(form, name, value) { const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; form.appendChild(input); }
    function saveToHiddenField() {
        const dataField = document.getElementById('mc-medals-data');
        if (dataField) dataField.value = JSON.stringify({ medals: state.medals, imageType: state.imageType, selectedClipart: state.selectedClipart, selectedRibbon: state.selectedRibbon, sportEvent: state.sportEvent });
    }
    function escapeHtml(str) { if (!str) return ''; return str.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]); }
    function showNotification(message, type = 'success') {
        document.querySelectorAll('.mc-notification').forEach(n => n.remove());
        const notification = document.createElement('div');
        notification.className = `mc-notification ${type}`;
        notification.innerHTML = `<span style="font-size:20px">${type === 'error' ? '&#9888;' : '&#10004;'}</span><span>${message}</span>`;
        document.body.appendChild(notification);
        setTimeout(() => { notification.style.opacity = '0'; notification.style.transform = 'translateX(100%)'; setTimeout(() => notification.remove(), 300); }, 4000);
    }
    
    // Switch between main tabs (Design / Ribbon / Text)
    function switchTab(tabName) {
        // Update tab buttons
        document.querySelectorAll('.mc-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        // Update panes
        document.querySelectorAll('.mc-tab-pane').forEach(pane => {
            pane.classList.toggle('active', pane.id === `mc-pane-${tabName}`);
        });
    }
    
    // Quantity controls
    function increaseQty() {
        state.medals.push({ line1: '', line2: '', line3: '' });
        updateQtyDisplay();
        renderMedals();
        updateNavButtons();
        updatePrice();
        autosave();
    }
    
    function decreaseQty() {
        if (state.medals.length <= 1) return;
        state.medals.pop();
        if (state.currentPreview >= state.medals.length) {
            state.currentPreview = state.medals.length - 1;
        }
        updateQtyDisplay();
        renderMedals();
        updateNavButtons();
        updatePrice();
        autosave();
    }
    
    function setQty(value) {
        let newQty = parseInt(value) || 1;
        if (newQty < 1) newQty = 1;
        
        const currentQty = state.medals.length;
        
        if (newQty > currentQty) {
            // Add medals
            for (let i = currentQty; i < newQty; i++) {
                state.medals.push({ line1: '', line2: '', line3: '' });
            }
        } else if (newQty < currentQty) {
            // Remove medals from the end
            state.medals.splice(newQty);
            if (state.currentPreview >= state.medals.length) {
                state.currentPreview = state.medals.length - 1;
            }
        }
        
        updateQtyDisplay();
        renderMedals();
        updateNavButtons();
        updatePrice();
        autosave();
    }
    
    function updateQtyDisplay() {
        const qtyInput = document.getElementById('mc-qty-input');
        if (qtyInput) qtyInput.value = state.medals.length;
    }
    
    // Apply Medal 1's text to all other medals
    function applyToAll() {
        if (state.medals.length < 2) {
            showNotification('Add more medals first', 'error');
            return;
        }
        const first = state.medals[0];
        for (let i = 1; i < state.medals.length; i++) {
            state.medals[i].line1 = first.line1;
            state.medals[i].line2 = first.line2;
            state.medals[i].line3 = first.line3;
        }
        renderMedals();
        showNotification(`Applied Medal 1 text to all ${state.medals.length} medals`);
    }
    
    // Toggle "same for all" mode
    function toggleSameForAll(checked) {
        state.sameForAll = checked;
        if (checked && state.medals.length > 0) {
            applyToAll();
        }
        // Hide/show individual medal cards (optional - keep them visible but sync)
        const cards = document.querySelectorAll('.mc-medal-card');
        cards.forEach((card, i) => {
            if (i > 0) {
                card.style.opacity = checked ? '0.5' : '1';
                card.querySelectorAll('input').forEach(input => input.disabled = checked);
            }
        });
    }

    window.medalCustomizer = { open, close, addMedal, removeMedal, updateMedal, setPreview, prevMedal, nextMedal, jumpToMedal, setImageType, handleUpload, removeUpload, selectClipart, clearClipart, selectRibbon, addToCart, switchTab, applyToAll, toggleSameForAll, increaseQty, decreaseQty, setQty, getState: () => state };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    console.log('%c[OK] Medal Customizer V1.3 READY', 'background: #28a745; color: white; padding: 5px;');
})();